import {
  Checkbox,
  DefaultButton,
  Dropdown,
  PrimaryButton,
  TextField,
} from "@fluentui/react";
import React, { useContext, useEffect, useState } from "react";
import { t } from "i18next";

import "./CustomiseTemplate.css";
import FroalaEditor from "react-froala-wysiwyg";

import "./ReportDetailsSection.css";
import { ACTIONS, BORDER, USERTYPES } from "../../../constants/Constants";
import { getClientsList, getFirmsList } from "../../../service/MasterService";
import userContext from "../../../context/users/UserContext";
import Select from "react-select";
import themeContext from "../../../context/theme/ThemeContext";
import { constantStyleForSelect } from "../../../components/CustomSelect";
import { getEnv } from '../../../helpers/EnvHelper';

const ReportTemplateDetailSection = (props) => {
  const [clientList, setClientList] = useState([]);
  const { getThemeColor } = useContext(themeContext);
  const { firmId } = useContext(userContext);
  const dropDownStyle = {
    dropdown: {
      width: "100%",
    },
    dropdownItemSelected: {
      fontSize: "12px",
      lineHeight: "18px",
      fontWeight: "600",
    },
    dropdownItemsWrapper: {
      maxHeight: "300px",
    },
    dropdownItem: {
      fontSize: "12px",
      lineHeight: "18px",
      fontWeight: "600",
    },
  };

  const fetchClientList = async (firmId) => {
    const response = await getFirmsList();
    let clientList = [];
    response.data.data.map((client) => {
      if (client.id === props.values.clientId) {
        props.setSelectedClientId({
          value: client.id,
          label: client.name,
        });
      }

      clientList.push({
        value: client.id,
        label: client.name,
      });
    });

    setClientList(clientList);
  };

  const fetchClientListForAdmin = async (firmId) => {
    const response = await getClientsList(firmId);
    let clientList = [];
    response.data.data.map((client) => {
      // if (client.id === props.values.clientId) {
      //   props.setSelectedClientId({
      //     value: client.id,
      //     label: client.name,
      //   });
      // }

      clientList.push({
        value: client.id,
        label: client.name,
      });
    });

    setClientList(clientList);
  };

  useEffect(() => {
    if (props.userRole === USERTYPES.FIRMADMIN || props.userRole === USERTYPES.SUPERVISOR) {
      fetchClientList(firmId);
    }
  }, [props.userRole]);

  const config = {
    placeholderText: "Edit Your Content Here!",
    key: getEnv("REACT_APP_FROALA_API_KEY"),
    charCounterCount: false,
    attribution: false,
    height: "70vh",
    width: "100%",
    fontSize: [
      "8",
      "9",
      "10",
      "10.67",
      "11",
      "12",
      "13",
      "13.33",
      "14",
      "14.67",
      "15",
      "16",
      "17",
      "17.33",
      "18",
      "18.67",
      "19",
      "21.33",
      "24",
      "30",
      "36",
      "48",
      "60",
      "72",
      "96",
    ],
    fontSizeDefault: "12",
    fontSizeUnit: 'px',
    lineHeights: {
      Default: '1.5',
      Single: '1',
      '1.15': '1.15',
      '1.5': '1.5',
      Double: '2'
    },
    wordPasteModal: false,
    pluginsEnabled: [
      "fullscreen",
      "codeBeautifier",
      "colors",
      "fontFamily",
      "fontSize",
      "paragraphFormat",
      "paragraphStyle",
      "align",
      "lists",
      "table",
      "wordPaste"
    ],
    toolbarButtons: {
      moreText: {
        buttons: [
          "undo",
          "redo",
          "|",
          "paragraphFormat",
          "|",
          "fontFamily",
          "|",
          "fontSize",
          "|",
          "bold",
          "italic",
          "underline",
          "strikeThrough",
          "clearFormatting",
          "|",
          "textColor",
          "backgroundColor",
          "|",
          "alignLeft",
          "alignCenter",
          "alignRight",
          "alignJustify",
          // 'inlineClass',
          // 'inlineStyle',
          "formatOL",
          "formatUL",
          "outdent",
          "indent",
          "|",
          "insertTable",
          "|",
          "copy",
        ],
        align: "left",
        buttonsVisible: 10,
      },
    },
  };


  return (
    <>
      <div
        className="tab-section modal-scroll"
        style={{
          padding: "0px",
          height: "100%",
          width: "100%",
          overflowY: "scroll",
        }}
      >
        <div style={{ width: "70%", padding: "10px 0px 10px 40px" }}>
          <section className="sectionA">
            <p
              style={{
                fontSize: "20px",
                fontWeight: "600",
                padding: "0px 0px",
              }}
            >
              {t("report-templates.report-template-details")}
            </p>
          </section>
          <div className="ms-Grid" dir="ltr" style={{ marginTop: "10px" }}>
            <div className="ms-Grid-row">
              <>
                <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                  <div className="report-template-list-key">
                    {t("navbar.modality")}
                  </div>
                  <Select
                    classNamePrefix="react-select"
                    options={props.modalityList}
                    defaultValue={props.selectedModality}
                    value={props.selectedModality}
                    styles={constantStyleForSelect(getThemeColor,props.errors.modalityId)}
                    onChange={(item) => {
                      props.setSelectedModality(item)
                      props.setValues({
                        ...props.values,
                        modalityId: "" + item.value,
                      });
                    }}
                  />
                  {props.errors.modalityId && (
                    <span
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        color: "red",
                      }}
                    >
                      {props.errors.modalityId}
                    </span>
                  )}
                </div>
              </>
              {/* <Dropdown
                className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6"
                label={t("navbar.modality")}
                styles={dropDownStyle}
                placeholder={t("report-templates.choose-option")}
                defaultSelectedKey={props.values.modalityId}
                options={props.modalityList}
                onChange={(e, selection) => {
                  props.values.modalityId = selection.key;
                }}
                errorMessage={props.errors.modalityIdList}
              /> */}
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                <div className="report-template-list-key">
                  {t("report-templates.title")}
                </div>
                <TextField
                  // className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                  // label={t("report-templates.title")}
                  name="title"
                  placeholder={"eg. knee fracture template"}
                  value={props.values.title}
                  onBlur={props.handleBlur}
                  onChange={(e) => {
                    props.handleChange(e);
                  }}
                  errorMessage={props.errors.title}
                />
              </div>
            </div>
            <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
              {props.radiologistList.length != 0 &&
                props.userRole === USERTYPES.ADMIN &&
                props.tabId == 1 &&
                props.action === ACTIONS.ADD && (
                  <>
                    <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                      <div className="report-template-list-key">
                        {t("report-templates.radiologist")}
                      </div>
                      <Select
                        classNamePrefix="react-select"
                        options={props.radiologistList}
                        defaultValue={props.selectedRadiologistId}
                        value={props.selectedRadiologistId}
                        placeholder={t("string-literals.report-template-radiologist")}
                        styles={constantStyleForSelect(getThemeColor,props.errors.radiologistId)}
                        onChange={(item) => {
                          props.setSelectedRadiologistId(item)
                          props.setValues({
                            ...props.values,
                            radiologistId: "" + item.value,
                          });
                        }}
                      />
                      {props.errors.radiologistId && (
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: "600",
                            color: "red",
                          }}
                        >
                          {props.errors.radiologistId}
                        </span>
                      )}
                    </div>
                  </>
                  // <Dropdown
                  //   className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6"
                  //   label={"Radiologist"}
                  //   styles={dropDownStyle}
                  //   placeholder={t("report-templates.choose-option")}
                  //   defaultSelectedKey={props.values.radiologistId}
                  //   options={props.radiologistList}
                  //   onChange={(e, selection) => {
                  //     props.setValues({
                  //       ...props.values,
                  //       radiologistId: "" + selection.key,
                  //     });
                  //     // props.values.radiologistId = selection.key.toString();
                  //     console.log(props.values.radiologistId);
                  //   }}
                  //   errorMessage={props.errors.radiologistId}
                  // />
                )}
              {(props.userRole === USERTYPES.ADMIN &&
                props.tabId == 3 &&
                props.action === ACTIONS.ADD) && (
                  <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                    <div className="report-template-list-key">
                      {t("report-templates.firm")}
                    </div>
                    <Select
                      classNamePrefix="react-select"
                      options={props.firmList}
                      defaultValue={props.selectedFirmId}
                      value={props.selectedFirmId}
                      placeholder={t("string-literals.report-template-firmId")}
                      styles={constantStyleForSelect(getThemeColor,props.errors.firmId)}
                     
                      onChange={(item) => {
                        props.setSelectedFirmId(item)
                        props.setValues({
                          ...props.values,
                          firmId: "" + item.value,
                          clientId: ""
                        });
                        props.setSelectedClientId(null);
                        fetchClientListForAdmin(item.value);
                      }}
                    />
                    {props.errors.firmId && (
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "red",
                        }}
                      >
                        {props.errors.firmId}
                      </span>
                    )}
                  </div>
                  // <Dropdown
                  //   className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6"
                  //   label={"Firm"}
                  //   styles={dropDownStyle}
                  //   placeholder={t("report-templates.choose-option")}
                  //   defaultSelectedKey={props.values.firmId}
                  //   options={props.firmList}
                  //   onChange={(e, selection) => {
                  //     props.setValues({
                  //       ...props.values,
                  //       firmId: "" + selection.key,
                  //     });
                  //     fetchClientList(selection.key);
                  //   }}
                  //   errorMessage={props.errors.firmId}
                  // />
                )}
              {((props.userRole === USERTYPES.ADMIN && props.tabId == 3) ||
                props.userRole === USERTYPES.FIRMADMIN || props.userRole === USERTYPES.SUPERVISOR) &&
                props.action === ACTIONS.ADD && (
                  <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                    <div className="report-template-list-key">
                      {t("report-templates.client")}
                    </div>
                    <Select
                      classNamePrefix="react-select"
                      options={clientList}
                      defaultValue={props.selectedClientId}
                      value={props.selectedClientId}
                      placeholder={t("string-literals.report-template-clientId")}
                      styles={constantStyleForSelect(getThemeColor,props.errors.clientId)}
                      onChange={(item) => {
                        props.setSelectedClientId(item)
                        props.setValues({
                          ...props.values,
                          clientId: "" + item.value,
                        });
                      }}
                    />
                    {props.errors.clientId && (
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "red",
                        }}
                      >
                        {props.errors.clientId}
                      </span>
                    )}
                  </div>
                  // <Dropdown
                  //   className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6"
                  //   label={"Client"}
                  //   styles={dropDownStyle}
                  //   placeholder={t("report-templates.choose-option")}
                  //   defaultSelectedKey={props.values.clientId}
                  //   options={clientList}
                  //   onChange={(e, selection) => {
                  //     props.setValues({
                  //       ...props.values,
                  //       clientId: "" + selection.key,
                  //     });
                  //   }}
                  //   errorMessage={props.errors.clientId}
                  // />
                )}
            </div>
          </div>
          <div style={{ padding: "10px" }}>
            <FroalaEditor
              tag="textarea"
              config={config}
              model={props.values.report}
              onModelChange={(e) => {
                props.values.report = e;
                console.log(props.values.report);
              }}
              style={{ marginTop: "20px", padding: "10px" }}
            />
            <span style={{ color: "red", fontSize: "12px", fontWeight: "400" }}>
              {props.errors.report}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReportTemplateDetailSection;
